/**
 * Enumeration of "abilities": string keys that
 * stand for account's permission, e.g. "account is able to ...".
 *
 * @see `useAbility`
 * @see `getHasAbility`
 */
export enum Ability {
  // AI
  AI_KEYWORD = 'ai_keyword',
  AI_AGENT = 'ai_agent',
  AI_ALWAYS_ON = 'ai_always_on',

  AGENCY_ANALYTICS = 'agency_analytics',
  AUTO_ASSIGN = 'auto_assign',

  COMMON_INTEGRATIONS = 'common_integrations',
  BROADCASTING = 'broadcasting',
  EMAIL_CHANNEL = 'email_channel',
  PAID_AUTOMATIONS = 'paid_automations',
  LIVECHAT = 'livechat',
  SMS_CHANNEL = 'sms_channel',
  WA_CHANNEL = 'wa_channel',
  SPREADSHEET_INTEGRATION = 'spreadsheet_integration',
  IMPORT = 'import',
  FREE_MC_BRANDING = 'free_mc_branding',
  SMART_SEGMENTS = 'smart_segments',
  MESSAGE_TAGS = 'message_tags',

  // Limit-based abilities
  USERS_TOTAL = 'users_total',
  LIVECHAT_SEATS = 'livechat_seats',
  VIEWERS = 'viewers',
  CHANNELS_COUNT = 'channels_count',
}
